<template>
  <div class="col">
    <server-table
      :count="mainCareerStatementsQuestionsCount"
      :DataItems="mainCareerStatementsQuestions"
      @Refresh="Refresh"
      @reset="filter = {}"
      :filter="filter"
      :title="'Career Statements'"
      edit_permission="add_tasks"
    >
      <template #columns>
        <el-table-column prop="question" label="question"></el-table-column>
        <el-table-column prop="" label="_">
          <template slot-scope="scope">
            <div class="main_actions">
              <i
                @click="openEditDialog(scope.row)"
                v-tooltip.top-center="'Edit Statement Questions'"
                class="fa fa-edit  actions-icons edit"
              ></i>
              <i
                @click="removeStatement(scope.row.id)"
                v-tooltip.top-center="'Delete Statement Questions'"
                class="fa fa-times actions-icons delete"
              ></i>
            </div>
          </template>
        </el-table-column>
      </template>
      <template #action>
        <div
          style="position:relative"
          @click="showDialog = true"
          wide
          class="text-capitalize"
        >
          <el-icon class="el-icon-plus"></el-icon>
          Add Career Statements Questions
        </div>
      </template>
    </server-table>

    <!-- Start -->
    <el-dialog
      :title="
        this.type == 1
          ? `Add Career statement Questions`
          : `Edit Career statement Questions`
      "
      :visible.sync="showDialog"
      width="60%"
      top="4vh"
    >
      <el-form
        :model="statementsData"
        ref="statementsRef"
        :rules="statementsDataRules"
        label-position="top"
      >
        <div class="row">
          <div class="col-md-6">
            <el-form-item :label="`${localization('Name')}`" prop="question">
              <el-input v-model="statementsData.question"></el-input>
            </el-form-item>
          </div>
          <div class="col-md-6">
            <el-form-item label="Language" prop="language">
              <el-select v-model="statementsData.language" style="width: 100%">
                <el-option
                  v-for="item in mainCareerStatementsQuestionsLanguages"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div
          class="
                  dialog-footer
                  dialog_footer
                "
        >
          <el-button
            class="text-center text-capitalize save_button delete_button"
            @click="showDialog = false"
          >
            {{ localization("Cancel") }}
          </el-button>
          <el-button
            type=""
            class="
                    text-center
                    text-capitalize
                    save_button
                  "
            @click="saveCareerStatementsQuestions"
          >
            Save
          </el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- End -->
  </div>
</template>

<script>
import ServerTable from "../../components/DataTablePagination.vue";
import "element-ui/lib/theme-chalk/display.css";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      filter: {},
      showDialog: false,
      type: 1,
      statementsQuestionsId: null,
      statementsData: {
        question: null,
        language: null
      },
      
    };
  },
  mounted() {
    this.Refresh();
  },
  methods: {
    Refresh(query) {
      this.$store.dispatch("user/handlerCareerStatementsQuestions", {
        query: query
      });
    },
    removeStatement(id) {
      Swal.fire({
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "error",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(date => {
        if (date.isConfirmed) {
          this.$store
            .dispatch("user/handleDeleteCareerStatementsQuestions", id)
            .then(_ => {
              this.Refresh(null);
              Swal.fire({
                icon: "success",
                type: "success",
                text: `${this.localization("Deleted")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                confirmButtonClass: "btn btn-success ",
                buttonsStyling: false
              });
            });
        }
      });
    },
    openDialog() {
      this.showDialog = true;
    },
    saveCareerStatementsQuestions() {
      this.$refs["statementsRef"].validate(valid => {
        if (valid) {
          if (this.type == 1) {
            this.$store
              .dispatch("user/handleAddrCareerStatementsQuestions", {
                query: this.statementsData
              })
              .then(_ => {
                this.showDialog = false;
                this.Refresh();
                this.statementsData.question = null;
                this.statementsData.language = null;
                Swal.fire({
                  title: "",
                  icon: "success",
                  text: `${this.localization("Done")}`,
                  confirmButtonText: `${this.localization("Ok")}`,
                  type: "success",
                  confirmButtonClass: "btn btn-success ",
                  buttonsStyling: false
                });
              });
          } else {
            this.$store
              .dispatch("user/handleUpdateCareerStatementsQuestions", {
                id: this.statementsQuestionsId,
                query: this.statementsData
              })
              .then(_ => {
                this.showDialog = false;
                this.Refresh();
                this.statementsData.question = null;
                this.statementsData.language = null;
                this.statementsQuestionsId = null;
                Swal.fire({
                  title: "",
                  icon: "success",
                  text: `${this.localization("Done")}`,
                  confirmButtonText: `${this.localization("Ok")}`,
                  type: "success",
                  confirmButtonClass: "btn btn-success ",
                  buttonsStyling: false
                });
              });
          }
        }
      });
    },
    openEditDialog(item) {
      this.showDialog = true;
      this.type = 2;
      this.statementsData.question = item.question;
      this.statementsData.language = item.language;
      this.statementsQuestionsId = item.id;
    }
  },
  computed: {
    mainCareerStatementsQuestions() {
      return this.$store.getters["user/getMainCareerStatementsQuestions"];
    },
    statementsDataRules() {
      return {
        question: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        language: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ]
      }
    },
    mainCareerStatementsQuestionsCount() {
      return this.$store.getters["user/getMainCareerStatementsQuestionsCount"];
    },
    mainCareerStatementsQuestionsLanguages() {
      return this.$store.getters[
        "user/getMainCareerStatementsQuestionsLanguages"
      ];
    }
  },
  components: {
    ServerTable
  }
};
</script>

<style lang="scss" scoped>
.main_actions {
  display: flex;
  padding: 5px 0;
  gap: 10px;
  justify-content: end;
  .actions-icons {
    font-size: 14px;
    width: 30px;
    height: 30px;
    box-shadow: 0 0 6px 0 rgba(#000, 0.2), 0 0 5px -2px rgba(#000, 0.1);
    text-align: center;
    line-height: 30px;
    border-radius: 50%;
    cursor: pointer;
    color: #777;
    transition: 0.3s;
    &.team_count {
      background-color: #11bfe3;
      color: #fff;
    }
    &.add {
      &:hover {
        background-color: #11bfe3;
        color: #fff;
      }
    }
    &.edit {
      &:hover {
        background-color: #ffa534;
        color: #fff;
      }
    }
    &.reinvite {
      &:hover {
        background-color: #3c3;
        color: #fff;
      }
    }
    &.delete {
      &:hover {
        background-color: #fb404b;
        color: #fff;
      }
    }
  }
}
.dialog_footer {
  display: flex;
  justify-content: end;
  align-items: center;

  @media (min-width: 320px) and (max-width: 991px) {
    justify-content: center;
  }
  .save_button {
    // background-color: #23ccef;
    border-color: #00563f;
    background-color: #00563f;
    min-width: 150px;
    color: #fff;
    @media (min-width: 320px) and (max-width: 767px) {
      min-width: 124px;
    }
    &.delete_button {
      background-color: #f56c6c;
      border-color: #f56c6c;
    }
  }
}
</style>
